export class OnLoadFocusHandler {
  static listen() {
    document.addEventListener('DOMContentLoaded', () => {
      const elementSelector = this.sanitizeHash(window.location.hash);
      this.scrollAndFocus(elementSelector);
    }, { once: true, passive: true });
  }

  private static scrollAndFocus(querySelector: string) {
    if (!querySelector) {
      return;
    }

    const element = this.findTargetElement(querySelector);
    if (!element) {
      return;
    }

    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (typeof element.focus === 'function') {
      element.focus();
    }
  }

  private static sanitizeHash(hash: string) {
    return hash.replace('#!', '');
  }

  private static findTargetElement(querySelector: string) {
    try {
      return document.querySelector(querySelector) as HTMLElement;
    } catch (error) {
      console.warn("Invalid element selector in URL hash, scroll and focus won't be applied", querySelector, error);
      return null;
    }
  }
}
